<template>
  <v-footer app inset class="hidden-sm-and-down d-md-flex px-auto py-0 text-caption">
    <span>&copy; {{ year }} - <a href="http://www.tesfri.fr" target="_blank" color="red" class="text-decoration-none">INNLOG</a></span>
    <v-spacer></v-spacer>

    <v-btn fab icon x-small href="https://www.facebook.com/profile.php?id=100017383572665" target="_blank">
      <v-icon color="indigo">fab fa-facebook-square</v-icon>
    </v-btn>
    <v-btn fab icon x-small href="https://fr.linkedin.com/company/tesfri" target="_blank">
      <v-icon color="cyan darken-1">fab fa-linkedin</v-icon>
    </v-btn>
    <v-btn fab icon x-small href="https://twitter.com/TESFRI" target="_blank">
      <v-icon color="#00acee">fab fa-twitter-square</v-icon>
    </v-btn>

    <router-link to="/Home/Privacy" class="text-decoration-none">Politique de confidentialité</router-link>
  </v-footer>
</template>

<script>
export default {
  name: "app-footer",
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>

<style lang="scss" scoped>
@import "app-footer.scss";
</style>
